export default "__VITE_ASSET__DL4$cfB1__"